export default __webpack_public_path__ + "assets/lokalia.d5bad7db.svg";